var map = {
	"./score_0.png": "c149",
	"./score_3.png": "3688",
	"./score_5.png": "01ab",
	"./score_6.png": "2699",
	"./score_8.png": "2d61",
	"./score_9.png": "ea27",
	"./score_C.png": "8995",
	"./score_D.png": "cbe8",
	"./score_S.png": "cdff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28d0";